"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var ScriptRender = function ScriptRender(_ref) {
  var classes = _ref.classes,
      _ref$content$attrs = _ref.content.attrs,
      url = _ref$content$attrs.url,
      height = _ref$content$attrs.height,
      isEditor = _ref.internals.isEditor;
  var html = "\n  <!DOCTYPE html>\n  <html lang=\"en\">\n    <head>\n    <title></title>\n    <script type=\"text/javascript\" src=\"".concat(url, "\"></script>\n    </head>\n    <body>\n    </body>\n  </html>\n  ");
  var isVideo = url !== undefined ? url.includes("embed") : false;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      overflow: "hidden",
      position: "relative",
      height: height !== undefined ? height : "25vh"
    }
  }, url === "" || url === undefined ? "<Insert script here />" : isVideo ? /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "Embed Video",
    src: url,
    width: "90%",
    height: "100%",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    scrolling: "no",
    allowFullScreen: true
  }) : /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "Embed Script",
    srcDoc: html,
    width: "90%",
    style: {
      left: "5%",
      position: "absolute"
    },
    height: "100%",
    frameBorder: "0",
    scrolling: "no"
  }));
};

var styles = function styles(theme) {
  return {
    container: {
      overflow: "hidden",
      paddingBottom: "80%",
      position: "relative",
      height: 0
    },
    frame: {
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
      position: "absolute"
    }
  };
};

var _default = (0, _withStyles["default"])(styles)(ScriptRender);

exports["default"] = _default;